export default __webpack_public_path__ + "static/media/edition-3-rot.0764b3b6.svg";